import React from 'react';
import { CountdownTimer } from './Countdown';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
export function FinalCta() {
  return <section aria-labelledby="final-cta-title" className="w-full bg-charcoal px-4 py-10 sm:px-6" data-id="element-77" data-mp="vhiw03u93ibh">
      <div className="mx-auto max-w-3xl text-center" data-id="element-78" data-mp="19cmbwdsq3tek">
        <span className="inline-block rounded-full bg-urgent px-3 py-1 font-head text-[10px] font-bold uppercase tracking-wider text-white sm:text-xs" data-id="element-79" data-mp="15ckj6u4yuabf">
          Limited-Time Offer
        </span>
        <h2 id="final-cta-title" className="mt-2 font-head text-2xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-80" data-mp="1ed0n24pmfjgt">
          Complete your professional teaching system today
        </h2>

        <CountdownTimer data-id="element-81" data-mp="1o5y6qe6cneh0" />

        <div className="mt-5 rounded-2xl bg-white p-5" data-id="element-82" data-mp="223d17xbgmcfu">
          <h3 className="font-head text-lg font-extrabold uppercase text-charcoal sm:text-2xl" data-id="element-83" data-mp="22462iirng9ql">
            Yoga Teaching Vault™
          </h3>
          <p className="text-xs text-softgray sm:text-sm" data-id="element-84" data-mp="n5uidrvj15c0">
            Complete 6-in-1 Box Set + 5 Strategic Bonuses
          </p>
          <p className="mt-2 text-sm text-softgray" data-id="element-85" data-mp="s5qmdr484wrk">
            Regular Price: <span className="line-through" data-id="element-86" data-mp="x41w81uir79s">$97</span>
          </p>
          <p className="font-head text-4xl font-extrabold text-brand sm:text-5xl" data-id="element-87" data-mp="x5v5zq0fi7m0">TODAY: $27</p>
          <span className="mt-1 inline-block rounded-full bg-urgent px-3 py-1 font-head text-[11px] font-bold uppercase tracking-wide text-white" data-id="element-88" data-mp="1246dvv75y81l">
            Save $70
          </span>

          <div className="mt-4 flex flex-col items-center" data-id="element-89" data-mp="1b1yxvcnty3vb">
            <CtaButton data-id="element-90" data-mp="1ftqgn10qv5aw" />
            <TrustRow className="mt-3" accessLabel="Instant Digital Access" data-id="element-91" data-mp="1fvkyg6gpyhar" />
          </div>
        </div>
      </div>
    </section>;
}